/*
 * SrAreaPicker — «Область экрана»: человек выбрал «Весь экран» и обводит мышью
 * часть, которую писать (24.10.2026, чат 713: игра в окне, вокруг окна жёлтая
 * рамка Windows 10 и 11 кадров в секунду из 60).
 *
 * Шаг между выбором экрана и отсчётом. Превью — сам захват; прямоугольник с
 * ручками; пропорции; стрелки и Enter/Esc. Результат — ДОЛИ кадра (SrRegion),
 * их режет движок записи (visibleRect, без холста) или композит.
 *
 * ⚠️ Захват на одном мониторе показывает сам браузер — игры за ним не видно.
 * Поэтому пока страница не в фокусе (человек переключился на игру), картинки
 * захвата откладываются; по возвращении превью останавливается на кадре,
 * снятом ДО возвращения (иначе на нём был бы уже снова браузер). Кнопка
 * «Вживую» возвращает живое превью.
 *
 * ⚠️ Захват читается через КЛОН трека: отмена читателя
 * MediaStreamTrackProcessor гасит сам трек, а этот трек дальше пишет запись.
 */
(function (w) {
    'use strict';

    var RATIOS = { free: 0, '16:9': 16 / 9, '9:16': 9 / 16, '1:1': 1, '4:3': 4 / 3 };
    var SNAP_EVERY_MS = 250;      // как часто откладывать кадр, пока человек в другом окне
    var SNAP_KEEP = 8;            // сколько отложенных кадров держать (≈2 с)
    var SNAP_BEFORE_RETURN_MS = 700;   // кадр «до возвращения»: позже — уже снова браузер
    var SNAP_MAX_SIDE = 1600;     // отложенный кадр уменьшается: он только для глаза

    function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

    function open(o) {
        var R = w.SrRegion;
        if (!R || !o || !o.stream || !o.root || !o.canvas || !o.sel) return Promise.resolve(null);
        var track0 = o.stream.getVideoTracks()[0];
        if (!track0 || track0.readyState !== 'live') return Promise.resolve(null);
        var tel = typeof o.onTel === 'function' ? o.onTel : function () {};
        var L = o.L || {};
        var root = o.root, cv = o.canvas, sel = o.sel, dimEl = o.dim, tagEl = o.tag, liveBtn = o.liveBtn;
        var ctx = cv.getContext('2d');
        var t0 = performance.now();

        return new Promise(function (resolve) {
            var done = false;
            var track = null, reader = null, video = null;
            var last = null;               // последний VideoFrame захвата
            var srcW = 0, srcH = 0;
            var rect = null;               // доли
            var ar = 0;                    // пропорция, 0 — свободно
            var mode = 'live';             // 'live' | 'snap'
            var snaps = [];                // [{at, c}] — отложенные кадры
            var snapShown = null;
            var awayAt = 0, lastSnapAt = 0, usedSnap = false;
            var raf = 0, img = { x: 0, y: 0, w: 0, h: 0 };
            var drag = null;
            var ro = null;

            // ── источник ─────────────────────────────────────────────
            try { track = track0.clone(); } catch (_) { track = null; }
            if (track && typeof w.MediaStreamTrackProcessor === 'function') {
                try {
                    reader = new w.MediaStreamTrackProcessor({ track: track }).readable.getReader();
                } catch (_) { reader = null; }
            }
            if (reader) {
                (async function pump() {
                    while (!done) {
                        var r;
                        try { r = await reader.read(); } catch (_) { break; }
                        if (r.done) break;
                        if (done) { try { r.value.close(); } catch (_) {} break; }
                        try { if (last) last.close(); } catch (_) {}
                        last = r.value;
                        if (!srcW) firstFrame(last.displayWidth || last.codedWidth, last.displayHeight || last.codedHeight);
                        if (isAway()) keepSnap();
                    }
                })();
            } else {
                // Firefox и прочие без MediaStreamTrackProcessor: живое превью
                // через <video>; отложенных кадров нет (скрытая вкладка не рисует).
                video = document.createElement('video');
                video.muted = true; video.playsInline = true; video.autoplay = true;
                video.srcObject = new MediaStream([track || track0]);
                video.addEventListener('loadedmetadata', function () { if (!srcW) firstFrame(video.videoWidth, video.videoHeight); });
                var pp = video.play(); if (pp && pp.catch) pp.catch(function () {});
            }
            track0.addEventListener('ended', onEnded);

            function firstFrame(W, H) {
                if (!(W > 0) || !(H > 0)) return;
                srcW = W; srcH = H;
                root.style.setProperty('--sr-area-ar', String(W / H));
                // запомненная область — только для экрана того же размера
                var rem = o.remembered && o.remembered.key === R.key(W, H) ? R.normalize(o.remembered.rect) : null;
                rect = rem || { x: 0.15, y: 0.15, w: 0.7, h: 0.7 };
                if (o.remembered && o.remembered.ar && RATIOS[o.remembered.ar] !== undefined) setRatio(o.remembered.ar, true);
                tel('record_area_shown', { src: R.key(W, H), remembered: rem ? 1 : 0 });
                if (typeof o.onReady === 'function') { try { o.onReady({ w: W, h: H }); } catch (_) {} }
                layout();
            }

            // ── отложенные кадры (человек в другом окне) ─────────────
            function isAway() { return document.hidden || (typeof document.hasFocus === 'function' && !document.hasFocus()); }
            function keepSnap() {
                var now = performance.now();
                if (now - lastSnapAt < SNAP_EVERY_MS || !last) return;
                lastSnapAt = now;
                var fw = last.displayWidth || last.codedWidth, fh = last.displayHeight || last.codedHeight;
                var k = Math.min(1, SNAP_MAX_SIDE / Math.max(fw, fh));
                var c = snaps.length >= SNAP_KEEP ? snaps.shift().c : document.createElement('canvas');
                c.width = Math.max(1, Math.round(fw * k)); c.height = Math.max(1, Math.round(fh * k));
                try { c.getContext('2d').drawImage(last, 0, 0, c.width, c.height); } catch (_) { return; }
                snaps.push({ at: now, c: c });
            }
            function onAway() {
                if (done || awayAt) return;
                awayAt = performance.now();
                snaps.length = 0;
            }
            function onBack() {
                if (done || !awayAt || isAway()) return;
                var back = performance.now(), away = back - awayAt;
                awayAt = 0;
                if (!snaps.length || away < 600) return;
                // кадр за SNAP_BEFORE_RETURN_MS до возвращения, но не самый
                // первый (на нём бывает переключатель окон Alt+Tab)
                var want = back - SNAP_BEFORE_RETURN_MS, pick = snaps[0];
                for (var i = 0; i < snaps.length; i++) if (snaps[i].at <= want) pick = snaps[i];
                snapShown = pick.c;
                mode = 'snap';
                usedSnap = true;
                tel('record_area_snapshot', { awayMs: Math.round(away), kept: snaps.length });
                if (tagEl) tagEl.hidden = false;
                paint();
            }
            function onVis() { if (document.hidden) onAway(); else setTimeout(onBack, 0); }
            function onBlur() { onAway(); }
            function onFocus() { setTimeout(onBack, 0); }
            document.addEventListener('visibilitychange', onVis);
            w.addEventListener('blur', onBlur);
            w.addEventListener('focus', onFocus);
            if (liveBtn) liveBtn.addEventListener('click', goLive);
            function goLive() { mode = 'live'; snapShown = null; if (tagEl) tagEl.hidden = true; paint(); }

            // ── рисование ─────────────────────────────────────────────
            function layout() {
                var cw = root.clientWidth, ch = root.clientHeight;
                if (!cw || !ch) return;
                var dpr = Math.min(2, w.devicePixelRatio || 1);
                var bw = Math.round(cw * dpr), bh = Math.round(ch * dpr);
                if (cv.width !== bw || cv.height !== bh) { cv.width = bw; cv.height = bh; }
                if (srcW) {
                    var k = Math.min(cw / srcW, ch / srcH);
                    img = { w: srcW * k, h: srcH * k, x: (cw - srcW * k) / 2, y: (ch - srcH * k) / 2 };
                }
                place();
                paint();
            }
            function paint() {
                var dpr = cv.width / Math.max(1, root.clientWidth);
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.fillStyle = '#05070d';
                ctx.fillRect(0, 0, cv.width, cv.height);
                var src = mode === 'snap' && snapShown ? snapShown : (last || (video && video.readyState >= 2 ? video : null));
                if (!src || !img.w) return;
                try { ctx.drawImage(src, img.x * dpr, img.y * dpr, img.w * dpr, img.h * dpr); } catch (_) {}
            }
            function loop() {
                if (done) return;
                raf = requestAnimationFrame(loop);
                if (mode === 'live') paint();
            }
            raf = requestAnimationFrame(loop);
            if (typeof w.ResizeObserver === 'function') { ro = new ResizeObserver(layout); ro.observe(root); }

            // прямоугольник поверх картинки: в CSS-пикселях корня
            function place() {
                if (!rect || !img.w) { sel.hidden = true; return; }
                sel.hidden = false;
                sel.style.left = (img.x + rect.x * img.w) + 'px';
                sel.style.top = (img.y + rect.y * img.h) + 'px';
                sel.style.width = (rect.w * img.w) + 'px';
                sel.style.height = (rect.h * img.h) + 'px';
                var sz = R.sizeOf(rect, srcW, srcH);
                if (dimEl) dimEl.textContent = sz.w + ' × ' + sz.h;
                sel.setAttribute('aria-valuetext', sz.w + ' × ' + sz.h);
                if (typeof o.onChange === 'function') { try { o.onChange({ w: sz.w, h: sz.h }); } catch (_) {} }
            }

            // ── мышь / палец ──────────────────────────────────────────
            function toSrc(ev) {
                var b = root.getBoundingClientRect();
                return { x: (ev.clientX - b.left - img.x) * srcW / img.w, y: (ev.clientY - b.top - img.y) * srcH / img.h };
            }
            function onDown(ev) {
                if (!srcW || ev.button > 0) return;
                // плашка «Кадр из другого окна» со своей кнопкой: захват указателя
                // корнем увёл бы её click на корень, и «Вживую» не нажималась бы
                if (tagEl && tagEl.contains(ev.target)) return;
                var h = ev.target && ev.target.getAttribute && ev.target.getAttribute('data-h');
                var p = toSrc(ev);
                if (h) drag = { kind: 'resize', h: h, p: p, r0: rect };
                else if (ev.target === sel || sel.contains(ev.target)) drag = { kind: 'move', p: p, r0: rect };
                else {
                    if (p.x < 0 || p.y < 0 || p.x > srcW || p.y > srcH) return;
                    drag = { kind: 'new', p: p, r0: rect, moved: false };
                }
                drag.id = ev.pointerId;
                try { root.setPointerCapture(ev.pointerId); } catch (_) {}
                ev.preventDefault();
                try { sel.focus({ preventScroll: true }); } catch (_) {}
            }
            function onMove(ev) {
                if (!drag || ev.pointerId !== drag.id) return;
                var p = toSrc(ev), dx = p.x - drag.p.x, dy = p.y - drag.p.y;
                if (drag.kind === 'move') rect = R.moveBy(drag.r0, dx, dy, srcW, srcH);
                else if (drag.kind === 'resize') rect = R.resizeBy(drag.r0, drag.h, dx, dy, srcW, srcH, ar);
                else {
                    if (!drag.moved && Math.abs(dx) + Math.abs(dy) < 6 * srcW / Math.max(1, img.w)) return;
                    drag.moved = true;
                    rect = R.fromDrag(drag.p, p, srcW, srcH, ar);
                }
                place();
                ev.preventDefault();
            }
            function onUp(ev) {
                if (!drag || (ev && ev.pointerId !== drag.id)) return;
                if (drag.kind !== 'new' || drag.moved) tel('record_area_adjusted', { how: drag.kind });
                drag = null;
            }
            root.addEventListener('pointerdown', onDown);
            root.addEventListener('pointermove', onMove);
            root.addEventListener('pointerup', onUp);
            root.addEventListener('pointercancel', onUp);

            // ── клавиатура ────────────────────────────────────────────
            function onKey(ev) {
                if (done) return;
                if (ev.key === 'Escape') { ev.preventDefault(); finish(null, 'esc'); return; }
                if (ev.key === 'Enter' && (ev.target === sel || ev.target === root || ev.target === document.body)) { ev.preventDefault(); finish(rect, 'enter'); return; }
                if (ev.target !== sel || !rect || !srcW) return;
                var step = ev.shiftKey ? 20 : 2, dx = 0, dy = 0;
                if (ev.key === 'ArrowLeft') dx = -step; else if (ev.key === 'ArrowRight') dx = step;
                else if (ev.key === 'ArrowUp') dy = -step; else if (ev.key === 'ArrowDown') dy = step;
                else return;
                ev.preventDefault();
                // Alt — менять размер (правый нижний угол), без него — двигать
                rect = ev.altKey ? R.resizeBy(rect, 'se', dx, dy, srcW, srcH, ar) : R.moveBy(rect, dx, dy, srcW, srcH);
                place();
            }
            document.addEventListener('keydown', onKey, true);

            // ── пропорции и кнопки ────────────────────────────────────
            function setRatio(k, silent) {
                if (RATIOS[k] === undefined) k = 'free';
                ar = RATIOS[k];
                if (o.ratioChips) {
                    Array.prototype.forEach.call(o.ratioChips.querySelectorAll('[data-ar]'), function (b) {
                        var on = b.getAttribute('data-ar') === k;
                        b.classList.toggle('on', on);
                        b.setAttribute('aria-pressed', on ? 'true' : 'false');
                    });
                }
                o.__ratioKey = k;
                if (ar && rect && srcW) rect = R.withAspect(rect, ar, srcW, srcH);
                if (!silent) { tel('record_area_ratio', { ar: k }); place(); }
            }
            function onRatioClick(ev) {
                var b = ev.target.closest && ev.target.closest('[data-ar]');
                if (b) setRatio(b.getAttribute('data-ar'));
            }
            if (o.ratioChips) o.ratioChips.addEventListener('click', onRatioClick);
            function onGo() { finish(rect, 'button'); }
            function onFull() { finish('full', 'button'); }
            function onCancel() { finish(null, 'button'); }
            if (o.goBtn) o.goBtn.addEventListener('click', onGo);
            if (o.fullBtn) o.fullBtn.addEventListener('click', onFull);
            if (o.cancelBtn) o.cancelBtn.addEventListener('click', onCancel);

            function onEnded() { finish(null, 'ended'); }

            function finish(v, how) {
                if (done) return;
                done = true;
                cancelAnimationFrame(raf);
                if (ro) { try { ro.disconnect(); } catch (_) {} }
                document.removeEventListener('visibilitychange', onVis);
                w.removeEventListener('blur', onBlur);
                w.removeEventListener('focus', onFocus);
                document.removeEventListener('keydown', onKey, true);
                root.removeEventListener('pointerdown', onDown);
                root.removeEventListener('pointermove', onMove);
                root.removeEventListener('pointerup', onUp);
                root.removeEventListener('pointercancel', onUp);
                if (o.ratioChips) o.ratioChips.removeEventListener('click', onRatioClick);
                if (o.goBtn) o.goBtn.removeEventListener('click', onGo);
                if (o.fullBtn) o.fullBtn.removeEventListener('click', onFull);
                if (o.cancelBtn) o.cancelBtn.removeEventListener('click', onCancel);
                if (liveBtn) liveBtn.removeEventListener('click', goLive);
                track0.removeEventListener('ended', onEnded);
                if (reader) { try { reader.cancel().catch(function () {}); } catch (_) {} }
                if (track) { try { track.stop(); } catch (_) {} }
                if (video) { try { video.pause(); video.srcObject = null; } catch (_) {} }
                try { if (last) last.close(); } catch (_) {}
                last = null; snaps.length = 0; snapShown = null;
                if (tagEl) tagEl.hidden = true;
                var ms = Math.round(performance.now() - t0);
                if (v && v !== 'full') {
                    var n = R.normalize(v);
                    if (!n) v = 'full';
                    else {
                        var sz = R.sizeOf(n, srcW, srcH);
                        tel('record_area_done', { w: sz.w, h: sz.h, pct: Math.round(1000 * n.w * n.h) / 10, ar: o.__ratioKey || 'free', snap: usedSnap ? 1 : 0, ms: ms, how: how });
                        resolve({ rect: n, srcW: srcW, srcH: srcH, key: R.key(srcW, srcH), ar: o.__ratioKey || 'free', size: sz });
                        return;
                    }
                }
                if (v === 'full') { tel('record_area_full', { ms: ms }); resolve('full'); return; }
                tel('record_area_cancelled', { how: how, ms: ms });
                resolve(null);
            }
        });
    }

    w.SrAreaPicker = { open: open, RATIOS: RATIOS };
})(window);
